import { GroupsFilter, RolesFilter } from "../types/groupsAndRolesTypes";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";

export const rolesFilterInitialValues: RolesFilter = {
  name: "",
  description: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "name",
};

export const groupsFilterInitialValues: GroupsFilter = {
  name: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "name",
};
